import api from '../../services/api';
import moment from 'moment';
import _ from 'lodash';
import * as type from '../types';

export default {
    namespaced: true,
    state: {
        headers: [
            { text: 'Date Uploaded', value: 'dateUploaded', sortable: true},
            { text: 'Batch ID', value: 'batchId', sortable: true},
            { text: 'User', value: 'currentUser', sortable: true},
            { text: 'Total Count', value: 'totalCount', sortable: true},
			{ text: 'Status', value: 'status', sortable: true, width: '200', formatter: row => `${row.status === 1 ?  'Ongoing' : 'Complete'}`},
			{ text: 'Actions', width: '150', align: 'center', alignHeader: 'center' }
        ],
        loading: false,
        loading2: false,
        allItems: [],
        items: [],
        itemsByBatchId: [],
        userRecords: [],
        statusRecords: []
    },
    getters: {
        headers: state => state.headers,
        items: state => state.items,
        loading: state => state.loading,
        loading2: state => state.loading2,
        itemsByBatchId: state => state.itemsByBatchId,
        userRecords: state => state.userRecords,
        statusRecords: state => state.statusRecords,
    },
    mutations: {
        setLoading: (state, payload) => state.loading = payload,
        setLoading2: (state, payload) => state.loading2 = payload,
        getAllitems: (state, payload) => state.allItems = payload,
        [type.QB_GET_LOGS]: (state, payload) => state.items = payload,
        [type.QB_GET_LOGS_BY_BATCHID]: (state, payload) => state.itemsByBatchId = payload,
        [type.GET_USER_RECORDS]: (state, payload) => state.userRecords = payload,
        [type.GET_STATUS_RECORDS]: (state, payload) => state.statusRecords = payload
    },
    actions: {
        [type.GET_USER_RECORDS]: async ({commit}) => {
            commit(type.GET_USER_RECORDS, []);
            try {
                let response = await api.get("/file/stored-list?searchFilter=Quickbooks");
                if(response.status == 200){
                    let result = response.data.map(e => {
                        return e.curr_user
                    });
                    commit(type.GET_USER_RECORDS, [...new Set(result)]);
                }
            } catch (error) {
                commit(type.GET_USER_RECORDS, []);
            }
        },
        [type.GET_STATUS_RECORDS]: async ({commit}) => {
            let statusResult = [
                { value: 1, label: "Ongoing" },
                { value: 2, label: "Complete" },
            ]
            commit(type.GET_STATUS_RECORDS, statusResult);
        },
        [type.QB_GET_LOGS]: async ({commit}, payload) => {
            commit(type.QB_GET_LOGS, []);
            commit(`setLoading`, true);
            const { startDate, endDate, userName, status } = payload;
            let query = '';
            if(startDate && endDate){ query = query ? `${query}&startDate=${startDate}&endDate=${endDate}` : `startDate=${startDate}&endDate=${endDate}` }
            if(userName){ query = query ? `${query}&currentUser=${userName}` : `currentUser=${userName}` }
            if(status){ query = query ? `${query}&status=${status}` : `status=${status}` }

            try {
                let response = await api.get(`/file/stored-list?searchFilter=Quickbooks&${query}`);
                let result = response.data.map(e => {
                    let dateUploaded = moment(e.date_uploaded).utcOffset('+08:00').format('MM/DD/YYYY, hh:mm:ssA');
                    
                    return {
                        id: e.id,
                        batchId: e.batch_id,
                        currentUser: e.curr_user,
                        brandname: e.brand_name,
                        filename: e.file_name,
                        fileLink: e.file_link,
                        status: e.status,
                        totalCount: e.total_count,
                        dateUploaded
                    };
                });
                commit(type.QB_GET_LOGS, result)
            } catch (error) {
                commit(type.QB_GET_LOGS, []);
                commit(`global/${type.SET_MESSAGE}`, { type: 'error', message: error.data.err.msg }, { root: true });
            }finally{
                commit(`setLoading`, false);
            }
        },
        [type.QB_GET_LOGS_BY_BATCHID]: async ({commit}, payload) => {
            commit(`setLoading2`, true);
            commit(type.QB_GET_LOGS_BY_BATCHID, []);
            try {
                let response = await api.get(`/get/quickbooks-user-logs?batchId=${payload}`);
                let result = response.data.map(e => {
                    return { batch_id: payload, ...e }
                })
                commit(type.QB_GET_LOGS_BY_BATCHID, result);
                commit(`setLoading2`, false);
                return Promise.resolve(result)
            } catch (error) {
                console.log(error)
                commit(`setLoading2`, false);
                commit(`global/${type.SET_MESSAGE}`, { type: 'error', message: error.data.err.msg }, { root: true });
            }
        },
    }
}